const styles = (theme) => ({
  boxComponent: {
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowY: "auto",

    scrollBehavior: "smooth",
  },
});
export default styles;
